import styled from "styled-components";

const UseTerm = () => {
  return (
    <Container>
      <h3 className="title">소음방망이 이용약관</h3>
      <ul>
        <li>
          <strong>제1장 총칙</strong>
          <ul>
            <li>
              <strong>제1조 (목적)</strong>이 약관은 RS101(이하 “회사”) 에서
              제공하는 모바일 어플리케이션 "소음방망이"(이하 "앱")의 이용과
              관련하여 회사와 이용자 간의 권리, 의무 및 책임사항 등을 규정함을
              목적으로 합니다.
            </li>
            <li>
              <strong>제2조 (용어의 정의)</strong>
              <ul className="list-no">
                <li>
                  "앱"이란 이용자가 스마트폰 등의 모바일 기기를 통해 회사가
                  제공하는 소음 측정, 소음 민감도 검사, 칼럼 열람, 후기 게시판
                  등의 서비스를 이용할 수 있도록 제공되는 소프트웨어입니다.
                </li>
                <li>
                  "이용자"란 본 약관에 동의하고 앱을 설치 및 사용하는 자를
                  말합니다.
                </li>
                <li>
                  “회원”이란 앱에 개인정보를 제공하여 회원가입을 한 자를
                  말합니다.
                </li>
                <li>
                  본 조에 정하지 아니한 용어는 관련 법령 및 일반적인 상관례에
                  따릅니다.
                </li>
              </ul>
            </li>
            <li>
              <strong>제3조 (약관의 효력 및 변경)</strong>
              <ul className="list-no">
                <li>
                  본 약관은 앱 내 게시하거나 이용자에게 공지함으로써 효력이
                  발생합니다.
                </li>
                <li>
                  회사는 불가피한 여건이나 사정이 있을 경우 관련 법령을 위반하지
                  않는 범위에서 약관을 개정할 수 있습니다.
                </li>
                <li>
                  회사가 약관을 개정할 경우, 적용일자 및 개정내용, 개정사유 등을
                  명시하여 시행일의 7일 이전부터 앱 내에 게시하여 이용자에게
                  공지합니다.
                </li>
                <li>
                  변경된 약관은 그 시행일로부터 효력을 가지며, 회원이 시행일까지
                  거부 의사를 표시하지 않으면 동의한 것으로 간주합니다.
                </li>
              </ul>
            </li>
          </ul>
        </li>

        <li>
          <strong>제2장 회원 가입 및 이용</strong>
          <ul>
            <li>
              <strong>제5조 (회원가입)</strong>
              <ul className="list-no">
                <li>
                  이용자는 앱 내 가입 양식에 따라 정보를 입력하고 본 약관에
                  동의함으로써 회원가입을 신청할 수 있습니다.
                </li>
                <li>
                  회사는 다음 각 호의 사유에 해당하는 경우 회원가입을 거절하거나
                  사후에 자격을 제한 또는 박탈할 수 있습니다.
                  <ul className="list-alphabat">
                    <li>타인의 정보를 도용하거나 허위 정보를 입력한 경우</li>
                    <li>사회 질서 및 미풍양속을 저해할 목적이 명백한 경우</li>
                    <li>회사의 서비스 운영을 방해한 전력이 있는 경우</li>
                    <li>
                      만 14세 미만 아동이 법정대리인의 동의 없이 가입한 경우
                    </li>
                    <li>기타 부적절한 이용자로 판단되는 경우</li>
                  </ul>
                </li>
              </ul>
            </li>

            <li>
              <strong>제6조 (미성년자의 이용 제한)</strong>
              <ul className="list-no">
                <li>
                  본 앱은 만 14세 이상 이용자를 대상으로 하며, 만 14세 미만은
                  보호자 동의 없이 이용할 수 없습니다.
                </li>
                <li>
                  만 14세 이상 19세 미만이 유료 서비스를 이용할 경우,
                  법정대리인의 사전 동의가 필요합니다.
                </li>
                <li>
                  동의 없이 이용한 경우, 법정대리인이 계약을 취소할 수 있습니다.
                </li>
                <li>
                  회사는 이용자의 나이를 확인할 수 있으며, 무단 이용이 확인되면
                  서비스 이용을 제한 또는 취소할 수 있습니다.
                </li>
              </ul>
            </li>

            <li>
              <strong>제7조 (회원탈퇴 및 자격상실)</strong>
              <ul className="list-no">
                <li>
                  회원은 언제든지 앱 내 기능을 통해 자발적으로 탈퇴할 수
                  있습니다.
                </li>
                <li>
                  회사는 약관 위반 또는 부정 이용 시 사전 통지 후 자격을 박탈할
                  수 있습니다.
                </li>
                <li>장기 미이용 계정은 휴면 처리 또는 삭제될 수 있습니다.</li>
              </ul>
            </li>
          </ul>
        </li>

        <li>
          <strong>제3장 서비스의 이용</strong>
          <ul>
            <li>
              <strong>제8조 (서비스의 내용)</strong>
              <ul className="list-no">
                <li>스마트폰 마이크를 통한 실시간 소음 측정 및 녹음</li>
                <li>측정 소음의 분석 결과 제공</li>
                <li>소음 민감도 간이 및 심화 검사 기능</li>
                <li>층간소음 관련 전문 칼럼 제공</li>
                <li>후기 게시판 및 커뮤니티 기능 제공</li>
              </ul>
            </li>

            <li>
              <strong>제9조 (서비스 중단 및 변경)</strong>
              <ul className="list-no">
                <li>
                  다음 사유에 해당할 경우 서비스가 일시 중단될 수 있습니다.
                  <ul className="list-alphabat">
                    <li>시스템 점검, 교체 또는 고장</li>
                    <li>천재지변, 정전 등 불가항력적 사유</li>
                  </ul>
                </li>
                <li>
                  서비스 내용은 운영상 필요에 따라 변경될 수 있으며, 중대한 변경
                  시 사전 공지합니다.
                </li>
              </ul>
            </li>

            <li>
              <strong>제10조 (회원에 대한 통지)</strong>
              <br />
              회사는 앱 공지사항, 이메일, 푸시알림 등을 통해 개별 통지할 수
              있습니다.
            </li>

            <li>
              <strong>제11조 (이용자의 의무)</strong>
              <ul className="list-no">
                <li>타인의 정보를 도용하거나 허위 사실을 유포하는 행위</li>
                <li>서비스 기능을 악용하거나 부정한 방법으로 사용하는 행위</li>
                <li>서비스를 영리적 목적이나 본래 목적 외로 사용하는 행위</li>
                <li>다른 이용자에 대한 비방, 욕설, 협박 등 행위</li>
                <li>회사 또는 제3자의 지식재산권을 침해하는 행위</li>
                <li>악성코드 배포, 해킹 시도, 서비스 방해 행위</li>
              </ul>
            </li>
          </ul>
        </li>

        <li>
          <strong>제4장 개인정보 및 지적재산권</strong>
          <ul>
            <li>
              <strong>제12조 (개인정보 보호)</strong>
              <ul className="list-no">
                <li>
                  회사는 필요한 최소한의 정보를 수집하며, 개인정보처리방침에
                  따릅니다.
                </li>
                <li>
                  이용자는 개인정보에 대한 열람, 정정, 삭제, 동의 철회를 요청할
                  수 있습니다.
                </li>
              </ul>
            </li>

            <li>
              <strong>제13조 (지적재산권)</strong>
              <ul className="list-no">
                <li>
                  앱의 모든 콘텐츠 저작권은 회사 또는 정당한 권리자에게
                  귀속됩니다.
                </li>
                <li>
                  이용자는 회사의 사전 동의 없이 콘텐츠를 활용할 수 없습니다.
                </li>
              </ul>
            </li>
          </ul>
        </li>

        <li>
          <strong>제5장 면책 및 기타</strong>
          <ul>
            <li>
              <strong>제14조 (면책조항)</strong>
              <ul className="list-no">
                <li>
                  이용자의 단말기, 네트워크 상태 등 외부 요인으로 인한 장애는
                  회사 책임이 아닙니다.
                </li>
                <li>
                  분석 결과는 참고용이며, 법적 효력은 상황에 따라 달라질 수
                  있습니다.
                </li>
                <li>
                  녹음·측정된 데이터의 정확성 및 사용 목적에 따른 법적 효력을
                  보장하지 않습니다.
                </li>
              </ul>
            </li>

            <li>
              <strong>제15조 (분쟁해결 및 준거법)</strong>
              <ul className="list-no">
                <li>
                  회사는 이용자의 불만 및 의견을 접수하고 성실히 처리합니다.
                </li>
                <li>
                  본 약관은 대한민국 법률에 따라 해석되며, 분쟁 발생 시 관할
                  법원은 민사소송법에 따릅니다.
                </li>
              </ul>
            </li>

            <li>
              <strong>제16조 (기타)</strong>
              <ul>
                <li>
                  '소음방망이' 앱은 불쾌한 콘텐츠나 악의적 사용자를 용납하지
                  않습니다. 사용자가 문제 콘텐츠를 신고하거나 악의적인 사용자를
                  차단할 수 있는 기능이 포함되어 있습니다. 신고 접수된 내역은
                  매일 오전 9시에 관리자에 의해 조치되며, 24시간 이내에 콘텐츠
                  삭제와 해당 사용자를 퇴출시킬 수 있습니다.
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </Container>
  );
};

export default UseTerm;

const Container = styled.div`
  padding: 2.5rem;
  overflow: hidden scroll;
  height: 100%;
  h3 {
    font-size: 2rem;
    line-height: 2.4rem;
  }
  ul {
    padding: 2rem 0;
    display: flex;
    flex-direction: column;
    gap: 3rem;
    > li {
      display: flex;
      flex-direction: column;
      gap: 1.2rem;
      line-height: 1.6rem;
      > strong {
        font-size: 1.6rem;
      }
      ul {
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: 1.2rem;
        li {
          font-size: 1.2rem;
          display: flex;
          flex-direction: column;
          gap: 0.8rem;
          strong {
            font-size: 1.4rem;
          }
          ul {
            display: block;
            li {
              display: block;
            }
          }
        }
        &.list-no {
          counter-reset: item;
          display: flex;
          flex-direction: column;
          gap: 0.4rem;
          li {
            position: relative;
            padding-left: 1.4rem;
            counter-increment: item;
            &::before {
              content: counter(item) ". ";
              position: absolute;
              left: 0;
              color: #555;
            }
            ul {
              padding: 0.6rem 0;
              li {
              }
              &.list-alphabat {
                counter-reset: alphab;
                li {
                  position: relative;
                  padding-left: 1.4rem;
                  counter-increment: alphab;
                  &::before {
                    content: counter(alphab, lower-alpha) ". ";
                    position: absolute;
                    left: 0;
                    color: #555;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
